"use client";

import React from "react";
import styled from "styled-components";
import TextHTML from "@motorata/base-ui.components.atoms.text-html";
import {
  BODY_TYPE_CAR_ARRAY,
  BRANDS_ARRAY,
  findBrand,
  findModel, FUEL_ARRAY,
  MODELS_ARRAY
} from "@motorata/base-ui.data";
import Link from "@motorata/next.components.atoms.link";
import { H1, Title } from "@motorata/base-ui.components.atoms.typography";
import { CityType, ProvinceType } from "@motorata/base-ui.types.api";
import { blockPadding } from "@motorata/base-ui.components.atoms._atoms";

export const StyledLink = ({ href, query = {}, children, ...rest }) => {
  return <Link type="third" href={href} query={query} padding="0" {...rest}>{children}</Link>
}

const SeoCatalogOffersSection = ({ productType = "car", brand, model, province, provinces, cities, title, content } : {
  productType?: string
  brand?: string
  model?: string
  province?: ProvinceType
  provinces?: ProvinceType[]
  cities?: CityType[]
  title?: string
  content?: string
}) => {
  const brandObj = brand ? findBrand(brand) : null;
  const modelObj = model ? findModel(brand, model) : null;
  const modelsArray = brand ? MODELS_ARRAY[brand] : null;

  return (
    <MasterWrapper>
      <Wrapper>
        <Content>
          <StyledLink  href={`/oferty/car`} type="third">Samochody osobowe</StyledLink>
          <StyledLink  href={`/oferty/truck`} type="third">Samochody dostawcze</StyledLink>
          <StyledLink  href={`/oferty/motorbikes`} type="third">Motocykle</StyledLink>
        </Content>
      </Wrapper>
      <Wrapper>
        <Title type="third" marginBottom="S">
          Dostępne marki samochodów osobowych
        </Title>
        <Content>
          {BRANDS_ARRAY.map((brand, index) => (
            <StyledLink key={index} href={`/oferty/car/${brand[1]}`} type="third">{brand[0]}</StyledLink>
          ))}
        </Content>
      </Wrapper>
      {
        productType === "car" &&
        <>
          {!model && modelsArray && (
            <Wrapper>
              <Title type="third" marginBottom="S">
                {`Modele ${brandObj[0]}`}
              </Title>
              <Content>
                {modelsArray.map((model, index) => (
                  <StyledLink type="third" key={index} href={`/oferty/car/${brandObj[1]}/${model[1]}`}>
                    {brandObj[0]} {model[0]}
                  </StyledLink>
                ))}
              </Content>
            </Wrapper>
          )}
          {model && (
            <Wrapper>
              <Title type="third" marginBottom="S">
                {`Stan ${brandObj[0]} ${modelObj[0]}`}
              </Title>
              <Content>
                <StyledLink type="third" href={`/oferty/car/${brandObj[1]}/${modelObj[1]}`} query={{
                  states: "brandNew"
                }}>
                  Nowy {brandObj[0]} {modelObj[0]}
                </StyledLink>
                <StyledLink type="third" href={`/oferty/car/${brandObj[1]}/${modelObj[1]}`} query={{
                  states: "used"
                }}>
                  Używany {brandObj[0]} {modelObj[0]}
                </StyledLink>
              </Content>
            </Wrapper>
          )}
          {model && (
            <Wrapper>
              <Title type="third" marginBottom="S">
                {`Nadwozie ${brandObj[0]} ${modelObj[0]}`}
              </Title>
              <Content>
                {
                  BODY_TYPE_CAR_ARRAY.map((bodyType, index) => (
                    <StyledLink type="third" key={index} href={`/oferty/car/${brandObj[1]}/${modelObj[1]}`} query={{
                      bodyType: bodyType[1]
                    }}>
                      {brandObj[0]} {modelObj[0]} {bodyType[0]}
                    </StyledLink>
                  ))
                }
              </Content>
            </Wrapper>
          )}
          {model && (
            <Wrapper>
              <Title type="third" marginBottom="S">
                {`Rodzaje paliwa ${brandObj[0]} ${modelObj[0]}`}
              </Title>
              <Content>
                {
                  FUEL_ARRAY.map((fuel, index) => (
                    <StyledLink type="third" key={index} href={`/oferty/car/${brandObj[1]}/${modelObj[1]}`} query={{
                      fuel: fuel[1]
                    }}>
                      {brandObj[0]} {modelObj[0]} {fuel[0]}
                    </StyledLink>
                  ))
                }
              </Content>
            </Wrapper>
          )}
        </>
      }
      {title && <H1>{title}</H1>}
      {
        !!content && <TextHTML type="secondary" content={content} />
      }
    </MasterWrapper>
  );
};

export default SeoCatalogOffersSection;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  grid-gap: ${({ theme }) => theme.space.S};
`;

export const Wrapper = styled.div`
  margin: ${({ theme }) => theme.space.M} 0;
  max-width: 1300px;
`;

export const MasterWrapper = styled.div`
  ${blockPadding};
  margin: 0 auto;
  max-width: 1300px;
`;
